
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.325 2.742l.591.591H15c.458 0 .833.375.833.834A.836.836 0 0115 5H5a.836.836 0 01-.833-.833c0-.459.375-.834.833-.834h2.083l.592-.591a.84.84 0 01.583-.242h3.484a.84.84 0 01.583.242zM5 15.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667V7.5c0-.917-.75-1.667-1.667-1.667H6.666C5.75 5.833 5 6.583 5 7.5v8.333zM7.5 7.5h5c.458 0 .833.375.833.833V15a.836.836 0 01-.833.833h-5A.836.836 0 016.667 15V8.333c0-.458.375-.833.833-.833z","fill":"#9AA0B5"}})])
          )
        }
      }
    